<template>
  <div class="contentBox">
    <p class="title">{{title}}</p>
    <p class="txt" v-html="txt"></p>
  </div>
</template>

<script>

export default {
  name: "index",
  data() {
    return {
      title:'',
      text:'',
      txt:'',
    };
  },
  mounted(){
    var type = this.$route.query.type;
    if(type ==4){
      this.title = 'Speakio Premium Subscription Agreement';
      document.title = 'Speakio Premium Subscription Agreement';
      this.text = 'Effective Date: April 28, 2026';
      this.txt = "Welcome to Speakio Premium! This Premium Subscription Agreement (the 'Agreement') is a legal agreement between you ('User' or 'you') and Speakio2026 ('Speakio,' 'we,' 'us,' or 'our') governing your purchase and use of our paid subscription services (the 'Premium Service').\
        By purchasing, activating, or using a Speakio Premium subscription, you agree to be bound by this Agreement, which supplements our general Terms of Service.<br>\
        <strong>1. Description of Premium Service</strong><br/>\
        Speakio Premium (e.g., Speakio Pro) provides advanced AI-powered public speaking coaching features, which may include but are not limited to: unlimited AI scriptwriting, full-length multi-modal (visual/audio) speech diagnosis, premium scenario libraries, and ad-free priority processing. The specific features are subject to the description on the purchase page within the App.\
        <br/>\
        <br/>\
        <strong>2. Subscription Plans & Billing</strong><br/>\
        <strong>Plan Options:</strong><br/>\
        We offer various subscription periods, such as Weekly, Monthly, and Annual plans. The price and duration of each plan are displayed on the purchase screen prior to payment.\
        <br/>\
        <br/>\
        <strong>Payment Processing: </strong><br/>\
        All payments are securely processed through the billing system of the applicable app store (Apple App Store for iOS devices or Google Play Store for Android devices). We do not directly collect or store your credit card information.\
        <br/>\
        <br/>\
        <strong>Automatic Renewal: Your subscription will automatically renew at the end of each billing cycle unless you cancel it. </strong><br/>\
        The renewal charge will be applied to your Apple ID or Google Play account within 24 hours prior to the end of the current subscription period.<br/>\
        <br/>\
        <br/>\
        <strong>3. Free Trials</strong><br/>\
        <br/>\
        We may offer a free trial period for certain Premium plans.<br/>\
        <br/>\
        <strong>If you do not cancel the subscription at least 24 hours before the free trial ends, you will automatically be charged</strong> the applicable subscription fee for the plan you selected.<br/>\
        <br/>\
        Any unused portion of a free trial period will be forfeited when you purchase a premium subscription.<br/>\
        <br/>\
        <br/>\
        <strong>4. Cancellation Policy</strong><br/>\
        <br/>\
        <strong>How to Cancel:</strong> You can cancel your automatic renewal at any time. Because your payment is managed by Apple or Google, <strong>deleting your Speakio account or uninstalling the app will NOT cancel your subscription.</strong> You must cancel directly through your device's subscription settings:<br/>\
        <br/>\
        <strong>For iOS Users (Apple App Store):</strong> Go to your iPhone Settings > Tap your name (Apple ID) > Tap Subscriptions > Select Speakio > Tap Cancel Subscription.<br/>\
        <br/>\
        <strong>For Android Users (Google Play Store):</strong>  Open the Google Play Store app > Tap your Profile icon > Tap Payments & subscriptions > Tap Subscriptions > Select Speakio > Tap Cancel subscription.<br/>\
        <br/>\
        <strong>Post-Cancellation: </strong> If you cancel, your Premium Service will remain active until the end of your current paid billing cycle. We do not offer prorated refunds for mid-cycle cancellations. \
        <br/>\
        <br/>\
        <strong>5. Refunds</strong><br/>\
        <br/>\
        All subscription payments are handled exclusively by Apple or Google, and their respective refund policies apply:<br/>\
        <br/>\
        <strong>Apple (iOS): </strong>Apple manages all billing and refunds for iOS purchases directly. We cannot issue refunds on their behalf. You must request a refund through Apple's 'Report a Problem' page.<br/>\
        <br/>\
        <strong>Google (Android):</strong>Refunds for Android purchases are handled in accordance with Google Play's refund policies. You may request a refund directly through Google Play Customer Support.<br/>\
        <br/>\
        <br/>\
        <strong>6. Changes to Pricing and Plans</strong><br/>\
        <br/>\
        We reserve the right to modify our subscription plans or adjust pricing at any time. Any price changes will only apply to your next billing cycle. We or the respective app store will notify you of any price increases in advance, giving you the opportunity to cancel before the new price takes effect.<br/>\
        <br/>\
        <br/>\
        <strong>7. Account Restrictions</strong><br/>\
        <br/>\
        Premium subscriptions are for personal use only. You may not share your login credentials, resell, or distribute the Premium Service to third parties. We reserve the right to suspend or terminate your account without refund if we detect abusive behavior or unauthorized sharing.\
        <br/>\
        <br/>\
        <strong>8. Contact Us</strong><br/>\
        <br/>\
        If you have any questions or issues regarding your Premium subscription, please contact our support team at:\
        <br/>\
        <br/>\
        <strong>Email: </strong>zentimewise2@gmail.com<br/>\
        ";
    } else {
      this.title = 'Speakio Privacy Policy';
      document.title = 'Speakio Privacy Policy';
      this.text = 'Effective Date: April 26, 2026';
      this.txt = "We take your privacy seriously. This Privacy Policy explains how Speakio2026 collects, uses, and protects your information when you use the Speakio app.<br>\
<br>\
                  <span class='blod'>1. Information We Collect</span><br>\
<br>\
                  Account Information: Information provided during login (e.g., Email address, username via Google Sign-In).<br>\
<br>\
                  Camera and Microphone Data (Crucial): To provide our core AI diagnostic features, we require access to your device's camera and microphone. Camera and microphone permissions are accessed ONLY when you actively initiate a speaking practice session, and are strictly used for AI diagnostic analysis. We will NEVER listen in the background, record without your permission, or use this data for marketing purposes.<br>\
<br>\
                  Device and Usage Information: Device model, operating system version, unique device identifiers, and app usage logs (used for crash reporting and performance optimization).<br>\
<br>\
                  <span class='blod'>2. How We Use Your Information</span><br>\
<br>\
                  To Provide AI Diagnostics: We process your video, audio, and text data to generate speech analysis reports.<br>\
<br>\
                  Service Improvement: We may use anonymized, aggregated interaction data to optimize our prompt engineering and improve the user experience.<br>\
<br>\
                  <span class='blod'>3. Third-Party Data Sharing To deliver our core functionalities, we securely transmit specific data to trusted third-party service providers:</span><br>\
<br>\
                  AI API Providers: We utilize Tongyi Qianwen (通义千问) for our underlying AI model capabilities. Your practice data is sent to this provider via encrypted APIs strictly for analysis and report generation.br>\
<br>\
                  Payment Processors: Google Play Billing processes your payment information. We do not collect or store your credit card details.<br>\
<br>\
                  <span class='blod'>4. Data Storage and Retention</span><br>\
<br>\
                  Storage and Retention Policy: By default, your video, audio recordings, and diagnostic reports are stored permanently on our secure servers so you can review your historical progress at any time.<br>\
<br>\
                  User Control: You have full control over your data. You can manually delete any of your recordings and associated reports at any time directly within the app. Once manually deleted by you, the data will be permanently erased from our active servers.<br>\
<br>\
                  <span class='blod'>5. Your Privacy Rights Depending on your location, you have the right to access, correct, or request the deletion of your personal data. You can exercise these rights directly within the app settings or by contacting us at our support email.</span><br>\
<br>\
                  <span class='blod'>6. Children's Privacy Speakio is not intended for use by children under the age of 13 (or the applicable minimum age in your jurisdiction). We do not knowingly collect personal data from children.</span><br>\
<br>\
                  <span class='blod'>7. Contact Us If you have any questions about this Privacy Policy or your data, please contact us at: Email: zentimewise2@gmail.com</span><br>\
<br>\
                  "
    }
  },
  methods: {
    
  }
};
</script>
<style scoped>
  .contentBox{
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0 0 100px 0;
  }

  .contentBox .title{
    color: #000000;
    font-size: 40px;
    font-weight: bold;
    display: block;
    margin: 50px 0;
    text-align: center;
  }

  .contentBox .txt{
    color: #000000;
    font-size: 20px;
    display: block;
    padding: 0 100px;
    box-sizing: border-box;
  }
  
</style>



// WEBPACK FOOTER //
// src/index/text.vue